// @flow
import React from 'react';
import { ecoGreen } from '../colors';
import DefaultTheme from './theme';
/*::
  import type { Node } from 'react';
  import type { StatisticsTheme } from './theme';

  export type Props = {|
    title?: string;
    description?: Node;
    color?: string;
    theme?: StatisticsTheme;
  |};
*/

var Statistics = function Statistics(_ref
/*: Props */
) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? null : _ref$description,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? ecoGreen() : _ref$color,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme;
  return /*#__PURE__*/React.createElement(theme.Main, {
    color: color
  }, /*#__PURE__*/React.createElement(theme.Title, null, title), /*#__PURE__*/React.createElement(theme.Description, null, description));
};

export default Statistics;